/**
 * @Author: Alex Sorafumo <Yuion>
 * @Date:   24/11/2016 3:43 PM
 * @Email:  alex@yuion.net
 * @Filename: step.component.ts
 * @Last modified by:   alex.sorafumo
 * @Last modified time: 20/01/2017 3:45 PM
 */

import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input } from '@angular/core';

import { BaseWidgetComponent } from '../../../shared/base.component';

@Component({
    selector: 'accordion-step',
    template: `<!--
@Author: Alex Sorafumo <Yuion>
@Date:   24/11/2016 3:43 PM
@Email:  alex@yuion.net
@Filename: step.template.html
@Last modified by:   Yuion
@Last modified time: 15/12/2016 11:32 AM
-->

<div class="accordion-step">
    <div class="heading" (touchrelease)="toggle()">
        <div class="icon" [class.show]="show"></div>
        <div class="text" [innerHTML]="heading | safe"></div>
    </div>
    <div [@view]="show ? 'show' : 'hide'" class="content" [class.last]="model.last">
        <ng-content></ng-content>
    </div>
</div>`,
    styles: [`@charset "UTF-8";.heading{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:.5em;border-bottom:1px solid #ccc;cursor:pointer}.heading:hover{background-color:rgba(0,0,0,.1)}.content{overflow:hidden;border-bottom:1px solid #ccc}.content.last{border:none}.icon{height:1em;width:1em;margin-right:.5em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.icon:after{content:'˅'}.icon.show:after{content:'˄'}`],
    animations: [
        trigger('view', [
            state('show', style({ opacity: 1, height: '*' })),
            state('hide', style({ opacity: 0, height: 0 })),
            transition('* => *', animate('0.2s ease-out')),
        ]),
    ],
})
export class AccordionStepComponent extends BaseWidgetComponent {
    @Input() public show = false;
    @Input() public heading = '';
    @Input() public showChange = new EventEmitter();

    public model: { [name: string]: any } = {};

    public toggle(state?: boolean) {
        if (state === false || state === true) {
            this.show = state;
        } else {
            this.show = !this.show;
        }
        this.showChange.emit(this.show);
    }
}
